import { render, staticRenderFns } from "./IcoOrder.vue?vue&type=template&id=39e9d93a&scoped=true"
import script from "./IcoOrder.vue?vue&type=script&lang=js"
export * from "./IcoOrder.vue?vue&type=script&lang=js"
import style0 from "./IcoOrder.vue?vue&type=style&index=0&id=39e9d93a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e9d93a",
  null
  
)

export default component.exports